import React, { useCallback, useEffect, useState } from "react";
import PageContainer from "../../components/PageContainer";
import { AiOutlineMail } from "react-icons/ai";
import { BsTelephone } from "react-icons/bs";
import { getAboutCEO } from "../../api/about";
import ImageWithTooltip from "../../components/ImageWithTooltip";
import { getDataCommon } from "../../api/common";

const bgImg = "/images/hero-image.jpeg";

const Executive = ({ type = "aboutceo" }) => {
  const [pageData, setPageData] = useState(null);

  const getData = useCallback(async () => {
    try {
      const response = await getDataCommon(`${type}.json`);

      setPageData(response);
    } catch (error) {
      console.warn(error);
    }
  }, [setPageData, type]);

  useEffect(() => {
    getData();

    return () => {
      setPageData(null);
    };
  }, [getData]);

  return (
    <PageContainer
      bgImg={bgImg}
      title="ทำเนียบผู้บริหาร"
      className="!bg-[#DBE1E6]"
    >
      <>
        <div className="bg-white py-4">
          <div className="container mx-auto">
            <h2 className="font-semibold text-[var(--black-color)] text-4xl text-center">
              {pageData?.title ?? "ทำเนียบผู้บริหาร"}
            </h2>
          </div>
        </div>
        <div className="py-4 min-h-[800px]">
          <div className="container mx-auto">
            <div className="flex items-center justify-center w-full">
              <div className="p-2">
                <ImageWithTooltip
                  src={pageData?.image?.path}
                  width={266}
                  height={511}
                  alt={pageData?.image?.altText}
                />
              </div>
              <div className="flex items-center p-4">
                <div className="px-4">
                  <h3 className="text-[var(--base-color)] font-semibold">
                    <span className="block text-3xl">{pageData?.prefix}</span>
                    <span className="block text-5xl">{pageData?.name}</span>
                  </h3>
                  <div className="text-lg font-medium border-b border-dotted border-slate-700 py-4">
                    <p>{pageData?.position}</p>
                  </div>
                  <div className="py-4">
                    <a
                      className="text-2xl text-[var(--black-color)] font-semibold"
                      href="tel:+6625027802"
                    >
                      <div className="flex items-center py-1">
                        <BsTelephone className="text-slate-400 size-5" />
                        <span class="ml-2 text-2xl text-[var(--black-color)] font-semibold">
                          {pageData?.telno}
                        </span>
                      </div>
                    </a>
                    <a
                      className="text-2xl text-[var(--black-color)] font-semibold"
                      href={`mailto:${pageData?.email}`}
                      // to:teerawut.w@ncsa.or.th
                    >
                      <div className="flex items-center py-1">
                        <AiOutlineMail className="text-slate-400 size-5" />
                        <span class="ml-2 text-xl text-[var(--black-color)] font-semibold">
                          {pageData?.email}
                        </span>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div dangerouslySetInnerHTML={{ __html: pageData?.content }} />
          </div>
        </div>
      </>
    </PageContainer>
  );
};

export default Executive;
